import(/* webpackMode: "eager" */ "/home/runner/work/mappito/mappito/site/app/[locale]/search/error.tsx");
